import moment from 'moment';

import { serverDateTimeToLocalMoment } from '~/DateTimeUtils';

export const getEmailCommunicationSpecificIdentifier = (communication) => {
  return communication.specific_identifier;
};

export const getNamesOfMissingEmailsFromRecipients = (recipientsList) => {
  // removed emails are not sent as part of contact.emails - so if we can't find the contact_email it was probably removed
  return recipientsList
    .filter((ccContact) => !ccContact.contact.emails.find((contactEmail) => contactEmail.id === ccContact.email_id))
    .map((ccContact) => ccContact.contact_full_name);
};

const getContactEmailsArrayAsString = (contacts) => {
  return contacts && contacts.length !== 0
    ? contacts.map((contact) => `${contact.contact_full_name} &lt;${contact.email}&gt;`).join(', ')
    : '';
};

export const getForwardedEmailParticipants = (communication) => {
  const adjusterDetails = `${communication.adjuster} &lt;${communication.adjuster_email}&gt;`;
  const contactDetails = communication?.contact
    ? `${communication.contact.full_name} &lt;${communication.contact_email.email}&gt;`
    : `&lt;${communication.specific_identifier}&gt;`;

  if (communication.direction === 'Outgoing') {
    // An outgoing email's sole To recipient is the contact it was sent to.
    return { origEmailSender: adjusterDetails, origEmailTarget: contactDetails, targetRecipientType: 'to' };
  }

  // Incoming: only the adjuster_recipient_type records which line the adjuster was on.
  return {
    origEmailSender: contactDetails,
    origEmailTarget: adjusterDetails,
    targetRecipientType: communication.adjuster_recipient_type || undefined,
  };
};

export const getEmailText = ({
  origEmailSender,
  origEmailTarget,
  communication,
  ccContacts,
  emailHtmlBody,
  toContacts,
  targetRecipientType,
}) => {
  const targetIsTo = targetRecipientType === 'to';
  const targetIsCc = targetRecipientType === 'cc';
  const hasCcContacts = ccContacts && ccContacts.length !== 0;
  const emailText =
    '<span>------------Forwarded message------------</span><br/>' +
    `<span>From: ${origEmailSender}</span><br/>` +
    `<span>Date: ${moment(serverDateTimeToLocalMoment(communication.datetime)).format(
      'dddd, MMMM D, YYYY [at] h:mm:ss A'
    )}</span><br/>` +
    `<span>Subject: ${communication.subject}</span><br/>` +
    `<span>To: ${targetIsTo ? origEmailTarget : ''}${
      toContacts && toContacts.length !== 0 ? (targetIsTo ? ', ' : '') + getContactEmailsArrayAsString(toContacts) : ''
    }</span><br/>` +
    (hasCcContacts || targetIsCc
      ? `<span>Cc: ${targetIsCc ? origEmailTarget : ''}${
          (targetIsCc && hasCcContacts ? ', ' : '') + getContactEmailsArrayAsString(ccContacts)
        }</span><br/>`
      : '') +
    `<br/><br/>${emailHtmlBody}`;

  return emailText;
};
